import { Navigate, useParams } from 'react-router-dom'
import { asPipelineId } from '@ludus/core'
import { PipelineIdProvider } from '../data/PipelineIdContext.tsx'
import { PipelinesPage } from './PipelinesPage.tsx'

/**
 * Route boundary for `/pipelines/:pipelineId` (the kanban). Lifts the pipeline
 * id out of the URL and provides it to the data layer via context, then mounts
 * the existing `PipelinesPage` gate (loading / error / snapshot). A missing
 * param can't happen for this route, but we redirect to the list defensively.
 */
export function PipelineRoute() {
  const { pipelineId } = useParams<{ pipelineId: string }>()
  if (!pipelineId) return <Navigate to="/pipelines" replace />
  return (
    <PipelineIdProvider pipelineId={asPipelineId(pipelineId)}>
      <PipelinesPage />
    </PipelineIdProvider>
  )
}
